import { useMemo } from 'react';
import { getColorByProbability } from '../MonteCarloSimulation/chart.utils';
import { round } from 'lodash';

const useForecastParsedData = data => {
  const totalSimulations = useMemo(() => data?.total_simulations, [data]);
  const issuesStates = useMemo(() => data?.issues_states, [data]);
  const finishedWeeks = useMemo(() => {
    let totalProbability = 0;
    return data?.finished_weeks?.map(item => {
      totalProbability += Number(item.probability);
      const roundedTotalProbability = round(totalProbability, 3);
      const color = getColorByProbability(roundedTotalProbability);
      return {
        ...item,
        totalProbability: roundedTotalProbability,
        color
      };
    });
  }, [data]);
  const unfinished = useMemo(() => data?.unfinished, [data]);

  return {
    totalSimulations,
    issuesStates,
    finishedWeeks,
    unfinished
  };
};

export default useForecastParsedData;
